export default __webpack_public_path__ + "static/Nadeeka-c46fb3c1ce29f5e6e1f7d816e61de9af.png";